module.exports = __webpack_public_path__ + "static/media/check_agility.31e54fe4.png";